<script lang="ts" setup>
const privacyPolicyUrl = import.meta.env.VITE_PRIVACY_POLICY_URL || '#'
const termsUrl = import.meta.env.VITE_USER_AGREEMENT_URL || '#'
</script>

<template>
  <div class="flex flex-col" style="gap: 16px">
    <h4 style="font-weight: bold; font-size: 22px; color: #FFFFFF; margin: 0">
      Legal
    </h4>
    <div class="flex flex-col" style="gap: 8px">
      <a
        :href="privacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
        style="font-size: 16px; color: #FFFFFF; text-decoration: none"
      >
        Privacy Policy
      </a>
      <a
        :href="termsUrl"
        target="_blank"
        rel="noopener noreferrer"
        style="font-size: 16px; color: #FFFFFF; text-decoration: none"
      >
        Terms of Service
      </a>
    </div>
  </div>
</template>
